module.exports = "/static/media/alert_icon.dc706fdf.svg";